import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Home } from 'src/app/modules/shared/models/home.model';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';
import { StateService } from 'src/app/modules/shared/services/storage/state.service';
import {
  Meta,
  Title,
  TransferState,
  makeStateKey,
} from '@angular/platform-browser';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { isPlatformServer } from '@angular/common';
import { of } from 'rxjs';
import { debounceTime, first } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/modules/shared/services/storage/local-storage.service';
import { CountryDetail } from 'src/app/modules/shared/models/profile.mode';
import { STATIC_HOME_SCRIPT } from './static-script';
import { DynamicMetaService } from 'src/app/modules/shared/services/dynamic-meta.service';
import { ModuleDisplayTypes } from 'src/app/modules/shared/enum/module-types';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';
import { Url_Friendly_String } from 'src/app/modules/shared/helpers/helper';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  readonly itemLimit: number = 8;
  displayTypes = ModuleDisplayTypes;

  featuredSliderConfig = {
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    infinite: true,
    autoplay: true,
  };
  blackFridayFeaturedSliderConfig = {
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    infinite: true,
    autoplay: true,
  };
  readonly rowSliderConfig = {
    arrows: false,
    slidesToShow: 3.6,
    slidesToScroll: 3,
    infinite: false,
    dots: false,
  };
  readonly bannerConfig = {
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
  };
  homeItems: Home;
  isRtl: boolean = false;
  leftArrow;
  rightArrow;
  id;
  module: any;
  template: any;
  storeDetail: any;
  content: any;
  isServer: boolean = false;
  private staticHomeScript: any;
  isDesktopBreakpoint: boolean = false;

  constructor(
    private panelService: PanelService,
    private stateService: StateService,
    private activatedRoute: ActivatedRoute,
    private snackBarService: SnackBarService,
    private meta: Meta,
    private storeDetailResolver: StoreDetailService,
    private transferState: TransferState,
    private deviceDetector: DeviceDetectorService,
    private dynamicMetaService: DynamicMetaService,
    private localStorage: LocalStorageService,
    @Inject(PLATFORM_ID) platFormId: Object
  ) {
    this.isServer = isPlatformServer(platFormId);
    deviceDetector.$breakpoint().subscribe((sizes) => {
      this.isDesktopBreakpoint = sizes.matches;
      const sliderItems = this.isDesktopBreakpoint ? 3 : 2;
      this.featuredSliderConfig = {
        ...this.featuredSliderConfig,
        slidesToShow: sliderItems,
        slidesToScroll: sliderItems,
      };
      const blackFridaySliderItems = this.isDesktopBreakpoint ? 4 : 2;
      this.blackFridayFeaturedSliderConfig = {
        ...this.blackFridayFeaturedSliderConfig,
        slidesToShow: blackFridaySliderItems,
        slidesToScroll: blackFridaySliderItems,
      };
    });
  }

  ngOnInit(): void {
    this.loadHomeScript();

    if (this.activatedRoute.snapshot.routeConfig?.path == '') {
      this.getHomeList();
    }
    if (this.activatedRoute.snapshot.routeConfig?.path == 'home/:id') {
      let transferKey = this.generateStateKey('homeListById');
      this.id = this.activatedRoute.snapshot.paramMap.get('id');
      if (this.transferState.hasKey(transferKey)) {
        this.homeItems = this.transferState.get<any>(transferKey, []);
      } else this.getHomeById();
    }
    this.getLanguageStatus();

    this.storeDetail = this.storeDetailResolver.permissionInit;
    this.storeDetail?.static_pages.find((el) => {
      if (el.slug == 'about-us') {
        let text = el.content.replace(/<[^>]*>/g, '');
        this.content = text.split('\n', 1)[0];
        this.meta.addTags([{ name: 'description', content: this.content }]);
      }
    });
  }

  private loadHomeScript() {
    let generatedMeta = this.dynamicMetaService.loadMeta(STATIC_HOME_SCRIPT);
    this.staticHomeScript = generatedMeta;
  }

  private unloadHomeScript() {
    if (!this.staticHomeScript) return;
    this.dynamicMetaService.unLoadMeta(this.staticHomeScript);
  }

  getUrlFriendlyName(name: string) {
    return Url_Friendly_String(name);
  }

  getLanguageStatus() {
    this.stateService.getLanguageStatus().subscribe((lang) => {
      if (lang == 'ar' || lang == 'fa') {
        this.isRtl = true;
      } else {
        this.isRtl = false;
      }

      if (this.isRtl) {
        this.leftArrow =
          '<img class="prevArrowBtn" src="assets/images/icons/slider-arrow-left.svg"></img>';
        this.rightArrow =
          '<img class="nextArrowBtn" src="assets/images/icons/slider-arrow-right.svg"></img>';
      } else {
        this.leftArrow =
          '<img class="nextArrowBtn" src="assets/images/icons/slider-arrow-right.svg"></img>';
        this.rightArrow =
          '<img class="prevArrowBtn" src="assets/images/icons/slider-arrow-left.svg"></img>';
      }

      if (this.homeItems) {
        let temporary = this.homeItems;
        this.homeItems = null;
        this.setTimeout$(() => {
          this.homeItems = temporary;
        }, 100);
      }
    });
  }

  getHomeList() {
    let storeRegion: CountryDetail = !this.isServer
      ? this.localStorage.getItem('store-region')
      : '';
    this.panelService.getHomeList(storeRegion?.code).subscribe(
      (homeList) => {
        this.homeItems = homeList;
        if (this.homeItems?.meta_description) {
          this.meta.updateTag({
            name: 'description',
            content: this.homeItems.meta_description,
          });
        }
      },
      (error) => {}
    );
  }

  getHomeById() {
    this.panelService.getHomeById(this.id).subscribe((homeList) => {
      if (this.isServer) {
        this.transferState.set<any>(
          this.generateStateKey('homeListById'),
          homeList
        );
      }
      this.homeItems = homeList;
      if (!homeList.modules.length) {
        this.snackBarService.showSnackBar('Home is empty.', 'primary', 4000);
      }
    });
  }

  generateStateKey(key: string) {
    return makeStateKey<any>(key);
  }

  setTimeout$(cb: () => void, timer: number) {
    of(true).pipe(debounceTime(timer), first()).subscribe(cb);
  }

  ngOnDestroy() {
    this.unloadHomeScript();
  }
}
